import { CartPage } from '../../components/CartPage.js';

// Initialize cart page functionality
function initializeCartPage() {
  // Check if we're on a cart page
  const cartPage = document.querySelector('[data-cart-page]');
  if (!cartPage) {
    console.log('Cart main: No cart page found, skipping initialization');
    return;
  }

  // Initialize cart page component
  const cartPageInstance = new CartPage();
  
  // Make it globally available for debugging
  window.cartPage = cartPageInstance;
  
  console.log('Cart main: Cart page initialized');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCartPage);
} else {
  initializeCartPage();
}
